import { useDispatch, useSelector } from 'react-redux';

import { DriverFuelType, setSelectedFuelType } from '../driverAnalysisReducer';
import { getSelectedFuelType } from '../driverAnalysisSelectors';

export default function useSelectedFuelType() {
    const dispatch = useDispatch();
    return {
        selectedFuelType: useSelector(getSelectedFuelType),
        setSelectedFuelType: (fuelType: DriverFuelType) => dispatch(setSelectedFuelType(fuelType)),
    };
}
